// 上報 log 前的 credential redaction 工具集中地。
// 為 logger.js 與未來其他上報路徑共用,確保 denylist / regex pattern 不會
// 因 copy-paste 散落而漂移。

export const REDACTED_PLACEHOLDER = '[Redacted]';

// 深度上限同時防 circular reference 卡死與惡意/失控深 payload 拖累 main thread。
// 一般 REST/GraphQL response 鮮少超過 5 層,留 6 為實作邊界。
export const REDACT_MAX_DEPTH = 6;

// HTTP headers 用 case-insensitive denylist,避免 Authorization / Cookie 等
// 認證 token 以明文落進 Elasticsearch。
const SENSITIVE_HEADER_KEYS = new Set([
	'authorization',
	'cookie',
	'set-cookie',
	'proxy-authorization',
	'x-api-key',
	'x-auth-token',
	'x-csrf-token',
]);
// Body / response key 名以 regex 比對(寬鬆涵蓋 camelCase / snake_case / 大小寫變體)。
// `token` 已能命中 accessToken / refreshToken / sessionToken,額外明列 session /
// jwt 涵蓋 sessionId / jwtPayload 等不含 token 子字串的 credential key 名稱。
const SENSITIVE_BODY_KEY_PATTERN = /password|passwd|secret|token|session|jwt|api[-_]?key|credit[-_]?card|cvv|ssn/i;

export const redactHeaders = headers => {
	if (!headers || typeof headers !== 'object') {
		return headers;
	}

	const result = {};

	Object.keys(headers).forEach(key => {
		if (SENSITIVE_HEADER_KEYS.has(key.toLowerCase())) {
			result[key] = REDACTED_PLACEHOLDER;
		} else {
			result[key] = headers[key];
		}
	});

	return result;
};

// 深度遞迴 redact:string 嘗試 parse 成 JSON 再 redact 再 stringify;object /
// array 走 key 比對。depth 超過 REDACT_MAX_DEPTH 時停止遞迴,以原值回傳。
export const redactBody = (value, depth = 0) => {
	if (depth > REDACT_MAX_DEPTH || value === null || value === undefined) {
		return value;
	}

	if (typeof value === 'string') {
		try {
			const parsed = JSON.parse(value);

			if (parsed && typeof parsed === 'object') {
				return JSON.stringify(redactBody(parsed, depth + 1));
			}
		} catch (_) {
			// 非 JSON 字串原樣回傳
		}

		return value;
	}

	if (Array.isArray(value)) {
		return value.map(item => redactBody(item, depth + 1));
	}

	if (typeof value === 'object') {
		const result = {};

		Object.keys(value).forEach(key => {
			if (SENSITIVE_BODY_KEY_PATTERN.test(key)) {
				result[key] = REDACTED_PLACEHOLDER;
			} else {
				result[key] = redactBody(value[key], depth + 1);
			}
		});

		return result;
	}

	return value;
};
